const startGsapAnimation = (id, animateCb) => {
  // start animation
  //!tl !== null && animate()
  animateCb(id);
};

export default startGsapAnimation;
